import { documentNames, driverLicenceDocumentNames } from "src/constants";

export const getCustomerRole = (entities) => {
  return entities?.length > 0 ?
    (entities[0]?.entityType?.toLowerCase()?.includes("company")) ? "Guarantor" : "Applicant"
    : "Applicant";
};

export const convertValueToDecimal = ({ value = 0 }) => {
  return parseFloat(Number(value).toFixed(2));
}

export const hasDocument = (customer, names = []) =>
  !!customer?.documents?.some((doc) => names.includes(doc?.name));

export const hasDriverLicenceDocument = (customer) =>
  hasDocument(customer, driverLicenceDocumentNames);

export const hasIDDocument = (customer) =>
  hasDocument(customer, [documentNames.ID_DOCUMENT]);
